import { FORM_FIELD_CHANGE, PROCESS_HARDCODED_FORM_DATA } from "./form-entry-action-types";
import { ELOQUA_PREPOP_SUCCESS } from "../eloqua/eloqua-action-types";
import { GEOIP_FALLBACK, GEOIP_SUCCESS } from "../geoip/geoip-action-types";
import { PARSE_QUERY_PARAMS } from "../query-params/query-params-action-types";
import { conditionallyAssign } from "./form-entry-services";

const initialFormData = {
    first_name: "",
    last_name: "",
    company: "",
    email: "",
    role: "",
    phone: "",
    institutionSize1: "",
    howDidYouHearAboutUs1: "",
    country: "",
    state: "",
    anythingtoadd: "",
    ExplicitOptIn: false,
    Industry: "",
    elqFormName: "2016-Master-Form-Campaign",
    elqSiteID: "1294",
    "form-test": "Experience C-Pricing",
    importSourceMostRecent1: "US Business Resources Pricing Form",
    leadSourceMostRecent1: "Collateral Request",
    leadVehicle: "Search - Organic",
    assetType: "",
    EmailAssetCode: "",
    // RedirectCode
    CampaignID: "7010W000002b4xX",
    LandingPageURL: "",
    productSolutionOfInterest1: "",
    // sFDCLastCampaignStatus
    // url
    // emailName
    // gUID1
    // buyingJourney1
    lastAccessedAssetID1: "",
    omniformname: "corporate",
    subSector1: ""
    // mobile-submit
    // querystring
    // channel
    // MQLFlag
};

const formEntryReducer = (state = initialFormData, action) => {
    switch (action.type) {
        case FORM_FIELD_CHANGE:
            return {
                ...state,
                [action.name]: action.value
            };
        case ELOQUA_PREPOP_SUCCESS:
            return conditionallyAssign(state, action.response);
        case PROCESS_HARDCODED_FORM_DATA:
            return {
                ...state,
                ...action.hardcodedValues
            };
        case PARSE_QUERY_PARAMS:
            return {
                ...state,
                ...action.params,
                querystring: action.querystring
            };
        case GEOIP_SUCCESS:
            return {
                ...state,
                country: action.response.country,
                state: action.response.state
            };
        case GEOIP_FALLBACK:
            return {
                ...state,
                country: action.response.country
            };
        default:
            return state;
    }
};

export default formEntryReducer;
